import { z } from 'zod';

/**
 * Each restaurant has an `activeFeatureFlags: FeatureFlagKey[]` field.
 *
 * @example
 *  <FeatureEnabled flag="in-app-chat">
 *    <ChatWidget kind="support" />
 *  </FeatureEnabled>
 *
 * @example
 *  const showStoreTab = useFeatureEnabled('store-tab');
 */

/**
 * Adding a key to `FEATURE_FLAG_KEYS` below makes it selectable in the admin-web UI.
 */
export const FEATURE_FLAG_KEYS = [
  /** Show the Store tab in admin-native (online status, pause online orders). */
  'store-tab',
  /** Enable the in-app chat widget. */
  'in-app-chat',
  /** Show debug tools (e.g. PostHog test buttons). */
  'debug-tools',
] as const;

export const zFeatureFlagKey = z.literal(FEATURE_FLAG_KEYS);
export type FeatureFlagKey = z.output<typeof zFeatureFlagKey>;
